import * as React from 'react'
import Icon from '../../Icon/Icon'
import { tag } from '../../../services/ATInternetService'

interface IFacebookProps {
  url: string
}
class Facebook extends React.Component<IFacebookProps, {}> {
  constructor(props: IFacebookProps) {
    super(props)
  }
  public render() {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${this.props.url}`
    return (
      <a
        className="Facebook"
        onClick={this.shareFacebook}
        target="_blank"
        href={url}
      >
        <Icon name="facebook" alt="Partager sur facebook" />
      </a>
    )
  }

  private shareFacebook = () => {
    tag.sendClick({
      elem: this,
      name: 'share_fb',
      chapter1: 'Resultat',
      type: 'action',
    })
  }
}

export default Facebook



// WEBPACK FOOTER //
// ./src/components/Share/SocialMedia/Facebook.tsx